import { startBugsnag } from '@/services/bugsnag.ts';
import { initLogRocket } from '@/services/logrocket.ts';
import { initMixpanel } from '@/services/mixpanel.ts';
import { initBraze } from '@/services/braze.ts';
import { getAccountantExternalId } from '@/contexts/accountantExternalId.ts';

export const initObservability = () => {
  startBugsnag();
  initLogRocket();
  initMixpanel();

  // Braze needs an identified accountant. The external id is available synchronously from
  // the portal URL / session, so it can be initialized alongside the other services.
  const accountantExternalId = getAccountantExternalId();
  if (accountantExternalId) {
    void initBraze(accountantExternalId);
  }
};
